import PropTypes from "prop-types";
import StatusChip from "@components/ui-components/status-chip";
import { KYC_LABEL, KYC_TONE } from "@constants/panel/common";

const KYC_DOCS = [
    {
        key   : "pan_card",
        label : "PAN card",
        fields: [
            { key: "name", label: "Name" },
            { key: "number", label: "PAN number" }
        ]
    },
    {
        key   : "gst_number",
        label : "GST number",
        fields: [{ key: "number", label: "GSTIN" }]
    },
    {
        key   : "bank_account",
        label : "Bank account",
        fields: [
            { key: "account_holder_name", label: "Account holder" },
            { key: "account_number", label: "Account number" },
            { key: "ifsc_code", label: "IFSC code" }
        ]
    }
];

const KycSummary = ({ docs }) => (
    <div className="mt-6 divide-y divide-gray-100 rounded-lg border border-gray-200 text-left">
        {KYC_DOCS.filter((doc) => docs[doc.key]).map((doc) => {
            const value = docs[doc.key];
            return (
                <div key={doc.key} className="p-4">
                    <div className="flex items-center justify-between">
                        <span className="text-sm font-medium text-gray-900">{doc.label}</span>
                        <StatusChip tone={KYC_TONE[value.status] || "neutral"} label={KYC_LABEL[value.status] || value.status} />
                    </div>
                    <dl className="mt-2 grid grid-cols-2 gap-y-1 text-sm">
                        {doc.fields.map((field) => (
                            <div key={field.key} className="contents">
                                <dt className="text-muted">{field.label}</dt>
                                <dd className="text-right font-medium text-gray-900">{value[field.key] || "—"}</dd>
                            </div>
                        ))}
                    </dl>
                </div>
            );
        })}
    </div>
);

KycSummary.propTypes = {
    docs: PropTypes.object
};

KycSummary.defaultProps = {
    docs: {}
};

export default KycSummary;
